<template>
<section class="section wizard">
<div class="container">
	<div class="columns" v-if="!manager">
		<div class="column">
			<h2>Psychic Request for Proposal</h2>
		</div>
	</div>
	<div class="columns">
		<div class="column">
			<form>
				<div class="steps is-maxed" id="stepsDemo">
					<div class="step-item" :class="getStepBarClasses(1)">
						<div class="step-marker">
							1
						</div>
					</div>
					<div class="step-item" :class="getStepBarClasses(2)">
						<div class="step-marker">
							2
						</div>
					</div>
					<div class="step-item" :class="getStepBarClasses(3)">
						<div class="step-marker">
							3
						</div>
					</div>
					<div class="step-item" :class="getStepBarClasses(4)">
						<div class="step-marker">
							4
						</div>
					</div>
					<div class="step-item" v-if="!manager" :class="getStepBarClasses(5)">
						<div class="step-marker">
							5
						</div>
					</div>

					<div class="steps-content">
						<div class="step-content is-active" v-if="step === 1">
							<h3>Create Web and Phone Logins</h3>
							<div v-if="getSite() === 'COS' && !manager">
							<p>Circle of Stars is hiring the services of experienced Psychic Advisors, Intuitive Counselors, Astrologers, and Tarot Card Readers. We are seeking entrepreneurs who have a strong work ethic to serve others and meet the following criteria:</p>
<ul class="step-ul">
  <li><i class="fa fa-star"></i> You must have a US or Canadian based phone number</li>
  <li><i class="fa fa-star"></i> You can commit to being available 40 hours a week or more to build your online business</li>
  <li><i class="fa fa-star"></i> You are confident you have the skills to develop flourishing repeat business</li>
</ul>
<p>If you are qualified, please respond by providing the information requested in the spaces below. We will review your application and contact you as soon as a decision is made.</p>
<p>If you are having issues, please email&nbsp;<a href="mailto:circleofstars5@gmail.com" target="_blank">circleofstars5@gmail.com</a>&nbsp;or call <span style="white-space: nowrap;">1-619-722-0009</span>
</p>
</div>

<p v-if="getSite() === 'OS' && !manager">
	One Sun is interested in hiring experienced Intuitive Counselors, Astrologers, Tarot Card Readers, Psychics, and Clairvoyants as independent contractors. If you're interested, please provide the information requested in the spaces below. Once reviewed we will contact you immediately.
</p>
							<p>
								All fields are required. Press the Tab key to advance to the next field.
							</p>
							<label class="label">Referral Code <span style="font-size:16px; color:#333">(Optional)</span></label>
							<div class="field has-addons is-maxed">
								<div class="control has-icons-left is-expanded">
									<input class="input is-small" 
										@change="checkReferral" :class="{'is-danger': errors.referral}"
										v-model.trim="psychic.referral" 
										maxlength="6" type="text" placeholder="">
									<span class="icon is-small is-left">
									<i class="fa fa-user"></i>
									</span>
								</div>
								<div class="control">
									<button type="button" class="button is-small is-info has-tooltip-multiline has-tooltip-left" data-tooltip="If you have a referral code, please enter it here. Max 2 digits, no letters or special characters."><i class="fa fa-info"></i></button>
								</div>
							</div>
							<p class="help is-danger" v-if="errors.referral">
								{{ errors.referral }}
							</p>
							<label class="label">Create Your Psychic Name</label>
							<div class="field has-addons is-maxed">
								<div class="control has-icons-left is-expanded">
									<input class="input is-small " 
										@change="checkUsername" :class="{'is-danger': errors.username}" 
										v-model.trim="psychic.username"
										type="text" placeholder="">
									<span class="icon is-small is-left">
									<i class="fa fa-user"></i>
									</span>
								</div>
								<div class="control">
									<button type="button" class="button is-small is-info has-tooltip-multiline has-tooltip-left" data-tooltip="Up to 20 characters. It may contain spaces. This will be the name that customers will see. We recommend that you select a name that is user friendly, such as &quot;Lady of the Stars.&quot;"><i class="fa fa-info"></i></button>
								</div>
							</div>
							<p class="help is-danger" v-if="errors.username">
								{{ errors.username }}
							</p>
							<label class="label">Password</label>
							<div class="field has-addons is-maxed">
								<p class="control has-icons-left is-expanded">
									<input class="input is-small " 
										@change="checkPassword" :class="{'is-danger': errors.password}" 
										v-model.trim="psychic.password"
										type="password" placeholder="">
									<span class="icon is-small is-left">
									<i class="fa fa-lock"></i>
									</span>
								</p>
								<div class="control">
									<button type="button" class="button is-small is-info has-tooltip-multiline has-tooltip-left" data-tooltip="6 to 20 characters. No spaces"><i class="fa fa-info"></i></button>
								</div>
							</div>
							<p class="help is-danger" v-if="errors.password">
								{{ errors.password }}
							</p>
							<div class="field is-maxed">
								<label class="label">Confirm Password</label>
								<p class="control has-icons-left is-expanded">
									<input class="input is-small "  
										@change="checkConfirmPassword" :class="{'is-danger': errors.confirm_password}"
										v-model.trim="psychic.confirm_password"
										type="password" placeholder="Password">
									<span class="icon is-small is-left">
									<i class="fa fa-lock"></i>
									</span>
								</p>
							</div>
							<p class="help is-danger" v-if="errors.confirm_password">
								{{ errors.confirm_password }}
							</p>
							<label class="label">Create PIN</label>
							<div class="field has-addons is-maxed">
								<p class="control has-icons-left is-expanded">
									<input class="input is-small " 
										@change="checkPin" :class="{'is-danger': errors.pin}"
										v-model.trim="psychic.pin"
										Type="text" placeholder="1234">
									<span class="icon is-small is-left">
									<i class="fa fa-lock"></i>
									</span>
								</p>
								<div class="control">
									<button type="button" class="button is-small is-info has-tooltip-multiline has-tooltip-left" data-tooltip="4 digit PIN for calling in and using our phone service."><i class="fa fa-info"></i></button>
								</div>
							</div>
							<p class="help is-danger" v-if="errors.pin">
								{{ errors.pin }}
							</p>
						</div>
						<div class="step-content is-active" v-if="step === 2">
  <h3>Enter Name, Address, Email &amp; Phone</h3>
  <p>
	All fields are required. Press the Tab key to advance to the next field.
  </p>
  <label class="label">First Name</label>
  <div class="field is-maxed">
	<div class="control has-icons-left has-icons-right">
	<input class="input is-small" 
		@change="checkFirst" :class="{'is-danger': errors.first}"
		v-model.trim="psychic.first"
	type="text" placeholder="">
	<span class="icon is-small is-left">
	<i class="fa fa-user"></i>
	</span>
	</div>
  </div>
	<p class="help is-danger" v-if="errors.first">
		{{ errors.first }}
	</p>
  <label class="label">Last Name</label>
  <div class="field is-maxed">
	<div class="control has-icons-left has-icons-right">
	<input class="input is-small" 
		@change="checkLast" :class="{'is-danger': errors.last}"
		v-model.trim="psychic.last"
	type="text" placeholder="">
	<span class="icon is-small is-left">
	<i class="fa fa-user"></i>
	</span>
	</div>
  </div>
	<p class="help is-danger" v-if="errors.last">
		{{ errors.last }}
	</p>
  <label class="label">Address 1</label>
  <div class="field is-maxed">
	<div class="control has-icons-left has-icons-right">
	<input class="input is-small" 
		@change="checkAddress1" :class="{'is-danger': errors.address1}" 
		v-model.trim="psychic.address1"
		type="text" placeholder="">
	<span class="icon is-small is-left">
	<i class="fa fa-globe"></i>
	</span>
	</div>
  </div>
	<p class="help is-danger" v-if="errors.address1">
		{{ errors.address1 }}
	</p>
  <label class="label">Address 2</label>
  <div class="field is-maxed">
	<div class="control has-icons-left has-icons-right">
	<input class="input is-small" 
		@change="checkAddress2" :class="{'is-danger': errors.address2}" 
		v-model.trim="psychic.address2"
		type="text" placeholder="">
	<span class="icon is-small is-left">
	<i class="fa fa-globe"></i>
	</span>
	</div>
  </div>
	<p class="help is-danger" v-if="errors.address2">
		{{ errors.address2 }}
	</p>
  <label class="label">Country</label>
  <div class="field is-maxed">
	<p class="control has-icons-left">
	<span class="select is-small">
	<select @change="checkCountry" :class="{'is-danger': errors.country}" v-model="psychic.country">
		<option selected="select is-smalled" value="">Select Country</option>
		<option v-for="country in countries" :key="country.country_code" :value="country.country_code">{{ country.country_name }}</option>
	</select>
	</span>
	<span class="icon is-small is-left">
	<i class="fa fa-globe"></i>
	</span>
	</p>
  </div>
	<p class="help is-danger" v-if="errors.country">
		{{ errors.country }}
	</p>
  <label class="label">Zip/Postal Code</label>
  <div class="field is-maxed">
	<div class="control has-icons-left has-icons-right">
	<input class="input is-small" 
		@change="checkPostalCode" :class="{'is-danger': errors.postal_code}" 
		v-model.trim="psychic.postal_code"
	type="text" placeholder="">
	<span class="icon is-small is-left">
	<i class="fa fa-globe"></i>
	</span>
	</div>
  </div>
	<p class="help is-danger" v-if="errors.postal_code">
		{{ errors.postal_code }}
	</p>
  <label class="label">City</label>
  <div class="field is-maxed">
	<div class="control has-icons-left has-icons-right">
	<input class="input is-small" 
		@change="checkCity" :class="{'is-danger': errors.city}" 
		v-model.trim="psychic.city"
	type="text" placeholder="">
	<span class="icon is-small is-left">
	<i class="fa fa-globe"></i>
	</span>
	</div>
  </div>
	<p class="help is-danger" v-if="errors.city">
		{{ errors.city }}
	</p>
  <label class="label">{{ regionLabel }}</label>
  <div class="field is-maxed">
	<p class="control has-icons-left">
	<span class="is-small is-expanded" :class="{'select is-expanded': regionDomestic, 'input': !regionDomestic}">
	<select v-model="psychic.region" v-if="regionDomestic">
		<option selected="select is-smalled" value="">Select State/Prov.</option>
		<option v-for="state in stateList" :key="state.state_abbr" :value="state.state_abbr">{{state.state_name}}</option>
	</select>
	<input class="input is-small" 
		@change="checkRegion" :class="{'is-danger': errors.region}" 
		v-model.trim="psychic.region"
		v-if="!regionDomestic"
	type="text" placeholder="">
	</span>
	<span class="icon is-small is-left">
	<i class="fa fa-globe"></i>
	</span>
	</p>
  </div>
	<p class="help is-danger" v-if="errors.region">
		{{ errors.region }}
	</p>
  <label class="label">SS Number</label>
  <div class="field has-addons is-maxed">
	<div class="control has-icons-left has-icons-right is-expanded">
	<input class="input is-small" 
		@change="checkSsn" :class="{'is-danger': errors.Ssn}" 
		v-model.trim="psychic.ssn"
	type="text" placeholder="">
	<span class="icon is-small is-left">
	<i class="fa fa-user"></i>
	</span>
	</div>
	<div class="control">
	<button type="button" class="button is-small is-info has-tooltip-multiline has-tooltip-left" data-tooltip="9 digits. Do not include spaces or dashes.">
	<i class="fa fa-info"></i>
	</button>
	</div>
  </div>
	<p class="help is-danger" v-if="errors.ssn">
		{{ errors.ssn }}
	</p>
  <label class="label">Email</label>
  <div class="field has-addons is-maxed">
	<div class="control has-icons-left has-icons-right is-expanded">
	<input class="input is-small" type="email" 
		@change="checkEmail" :class="{'is-danger': errors.email}" 
		v-model.trim="psychic.email"
	placeholder="" value="">
	<span class="icon is-small is-left">
	<i class="fa fa-envelope"></i>
	</span>
	<span class="icon is-small is-right">
	<i class="fa fa-exclamation-triangle"></i>
	</span>
	</div>
  </div>
	<p class="help is-danger" v-if="errors.email">
		{{ errors.email }}
	</p>
  <label class="label">Primary Phone Number<br>
  <span>This will be the number we will call you on to provide readings.</span></label>
  <div class="field has-addons is-maxed">
	<p class="control ">
	<a class="button is-small is-static"> +{{ this.psychic.country_code }} </a>
	</p>
	<p class="control">
	<input class="input is-small is-expanded" type="tel" 
		@change="checkPhone" :class="{'is-danger': errors.phone}" 
		v-model.trim="phone"
	placeholder="">
	</p>
	<p class="control ">
	<span class="select is-small readonly">
	</span>
	</p>
  </div>
	<p class="help is-danger" v-if="errors.phone">
		{{ errors.phone }}
	</p>
  <label class="label">SMS Notifications<br>
  <span>Would you like to receive SMS notifications at this number (carrier charges may apply)?</span></label>
  <div class="field has-addons is-maxed">
	<p class="control">
	<input class="input is-small is-expanded" type="checkbox" 
		v-model="psychic.sms"
	placeholder="">
	</p>
	<p class="control ">
	<span class="select is-small readonly">
	</span>
	</p>
  </div>
  <label class="label">Preferred Contact Method</label>
  <div class="field is-maxed">
	<div class="control">
	<label class="radio">
	<input type="radio" v-model="psychic.contact_method" value="E">
	Email </label>
	<label class="radio">
	<input type="radio" v-model="psychic.contact_method" value="P">
	Phone </label>
	</div>
  </div>
</div>
<div class="step-content is-active" v-if="step === 3">
  <h3>Zodiac, Gender, Experience &amp; Languages</h3>
  <p>
	Please enter your zodiac, gender, experience and languages. These will be used to complement your listing for customers seeking individual traits.
  </p>
  <p>
	All fields are required. Press the Tab key to advance to the next field.
  </p>
  <label class="label">Zodiac Sign</label>
  <div class="field is-grouped is-maxed">
	<div class="control is-expanded has-icons-left">
	<div class="select is-small is-fullwidth">
		<select
		@change="checkZodiac" :class="{'is-danger': errors.zodiac}" 
		v-model="psychic.zodiac">
		<option value="">Select Zodiac Sign</option>
		<option value="1">Aries</option>
		<option value="2">Taurus</option>
		<option value="3">Gemini</option>
		<option value="4">Cancer</option>
		<option value="5">Leo</option>
		<option value="6">Virgo</option>
		<option value="7">Libra</option>
		<option value="8">Scorpio</option>
		<option value="9">Sagittarius</option>
		<option value="10">Capricorn</option>
		<option value="11">Aquarius</option>
		<option value="12">Pisces</option>
		</select>
		<span class="icon is-small is-left">
		<i class="fa fa-sun-o"></i>
		</span>
	</div>
	</div>
  </div>
	<p class="help is-danger" v-if="errors.zodiac">
		{{ errors.zodiac }}
	</p>
  <label class="label">Gender</label>
  <div class="field is-grouped is-maxed">
	<div class="control">
	<label class="radio">
	<input type="radio" v-model="psychic.gender" value="M">
	Male </label>
	<label class="radio">
	<input type="radio" v-model="psychic.gender" value="F">
	Female </label>
	</div>
  </div>
  <label class="label">Primary Language</label>
  <div class="field is-grouped is-maxed">
	<div class="control is-expanded has-icons-left">
	<div class="select is-small is-fullwidth">
		<select	:v-model="psychic.language" @change="fixOtherLanguages">
		<option :value="1">English</option>
		<option :value="2">Spanish</option>
		<option :value="3">French</option>
		<option :value="5">German</option>
		<option :value="6">Italian</option>
		<option :value="7">Russian</option>
		<option :value="8">Slovak</option>
		</select>
		<span class="icon is-small is-left">
		<i class="fa fa-sun-o"></i>
		</span>
	</div>
	</div>
  </div>
  <label class="label">Other languages you are fluent in</label>
  <div class="field is-maxed">
	<div class="control">
	<label class="label">
	<a class="button is-small is-primary" @click="languagesOpen = true"><i class="fa fa-pencil"></i></a>
	<span class="other-languages">{{selectedLanguageString}}</span></label>
	</div>
  </div>
  <label class="label">Years Experience</label>
  <div class="field has-addons is-maxed">
	<div class="control has-icons-left has-addons has-icons-right is-expanded">
	<input class="input is-small" 
		@change="checkExperience" :class="{'is-danger': errors.experience}" 
		v-model.trim="psychic.experience"
	maxlength="2" type="text" placeholder="">
	<span class="icon is-small is-left">
	<i class="fa fa-calendar"></i>
	</span>
	</div>
	<div class="control">
	<button type="button" class="button is-small is-info has-tooltip-multiline has-tooltip-left" data-tooltip="2 digits, no letters or special characters."><i class="fa fa-info"></i></button>
	</div>
  </div>
	<p class="help is-danger" v-if="errors.experience">
		{{ errors.experience }}
	</p>
  <h3 class="is-maxed">Credentials <span style="font-size:16px; color:#333">(Optional)</span></h3>
  <label class="label"><span>We recommend listing credentials. This can help your listing. Please have documentation to support any of your credentials. Credentials can include educational degrees, psychic membership organizations, affiliations and employment.</span></label>
  <div class="field has-addons is-maxed" v-for="(cred, idx) in psychic.credentials" :key="idx">
	<div class="control has-icons-left has-icons-right is-expanded">
	<input class="input is-small " type="text" v-model.trim="psychic.credentials[idx]">
	<span class="icon is-small is-left">
	<i class="fa fa-star"></i>
	</span>
	</div>
	<div class="control">
	<a class="button is-small is-danger" @click="removeCredential(idx)"><i class="fa fa-remove"></i></a>
	</div>
  </div>
  <div class="field is-maxed" v-if="psychic.credentials.length < 6">
	<div class="control">
	<a class="button is-small is-primary" @click="addCredential"><i class="fa fa-plus"></i></a>
	</div>
  </div>
</div>
						<div class="step-content is-active" v-if="(step === 4 && !manager)">
							<h3>Psychic Agreement &amp; Privacy Policy</h3>
							<p>
								Psychic Independent Contractor Agreement <a @click="printerFriendly()">Printer-friendly Version</a>
							</p>
							<p>
								<strong>YOU MUST SCROLL ALL THE WAY DOWN, READ, AND ACCEPT THIS INDEPENDENT CONTRACTOR AGREEMENT BEFORE YOU WILL BE PERMITTED TO PROCEED.</strong>
							</p>
							<iframe style="border: 1px solid gray; width: 100%; height: 300px; background-color:#fff;" id="fmeContractorAgreement" name="fmeContractorAgreement" :src="agreementUri()" marginheight="10" marginwidth="10" frameborder="0">
							</iframe>
							<div class="field is-grouped is-maxed">
								<label class="checkbox">
								<input type="checkbox" v-model="agreePrivacy">
								&nbsp;I have reviewed and agree to the Independent Contractor Agreement and the <a href="./privacy" target="_blank">Privacy Policy</a>
								</label>
							</div>
	<p class="help is-danger" v-if="errors.checkPrivacy">
		{{ errors.checkPrivacy }}
	</p>
							<div class="field is-grouped is-maxed">
								<label class="checkbox">
								<input type="checkbox" v-model="agreePsychic">
								&nbsp;I swear, under penalty of perjury that I possess psychic/clairvoyant gifts and I have experience as an intuitive counselor, tarot reader, astrologer or psychic.
								</label>
							</div>
	<p class="help is-danger" v-if="errors.checkPsychic">
		{{ errors.checkPsychic }}
	</p>
							<p>
								I certify that all of the above information is true, and allow {{ siteName() }}One Sun to look into any references they feel necessary.
							</p>
							<p>
								By completing the registration and clicking on the button labeled "I Agree," you are entering into a contract with {{ siteName() }} through a legally binding electronic signature. You are also consenting to use of electronic disclosures, agreements and records. To view our comprehensive electronic disclosure, including how to terminate your consent.
							</p>
						</div>
						<div class="step-content is-active" v-if="(step === 5 && !manager) || (step === 4 && manager)">
							<div class="columns thank-you">
								<div class="column">
									<h3>Thank you!</h3>
									<p>
										An administrator will contact you, usually within 24 hours, to review your registration. A confirmation e-mail has been sent to <strong>{{psychic.email}}</strong> containing important registration and login information.
									</p>
								</div>
							</div>
						</div>
					</div>
					<div class="steps-actions" v-if="(step !== 5 && !manager) || step !== 4 && manager">
						<div class="steps-action">
							<a @click="receedStep" class="button is-link" v-if="![1,5].includes(step)">Previous</a>
						</div>
						<div class="steps-action">
							<a @click="advanceStep" v-if="idle" class="button is-success"> {{ step === 4 ? "I Agree" : "Next" }}</a>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
	<Modal class="is-active" v-if="languagesOpen" @close="languagesOpen = false">
		<span slot="title">Select Additional Languages</span>
		<div slot="body">
			<div class="field is-grouped is-maxed" v-for="divIdx in langSelectDivCount" :key="divIdx">
				<div class="control">
					<label class="checkbox">
						{{ languages[languageKeyByIndex((divIdx-1)*2)]}} 
						<input type="checkbox" 
							:value="parseInt(languageKeyByIndex((divIdx-1)*2))" 
							v-model="psychic.languages" 
							:disabled="psychic.language === parseInt(languageKeyByIndex((divIdx-1)*2))">
					</label>
				</div>
				<div class="control" v-if="languages[languageKeyByIndex(((divIdx-1)*2)+1)]">
					<label class="checkbox">
						{{ languages[languageKeyByIndex(((divIdx-1)*2)+1)]}} 
						<input type="checkbox" 
							:value="parseInt(languageKeyByIndex(((divIdx-1)*2)+1))" 
							v-model="psychic.languages" 
							:disabled="psychic.language === parseInt(languageKeyByIndex(((divIdx-1)*2)+1))">
					</label>
				</div>
			</div>
		</div>
		<div class="field is-grouped" slot="footer">
			<div class="control">
				<a class="button is-small is-light" @click="languagesOpen = false">Close</a>
			</div>
		</div>
	</Modal>
</div>
</section>
</template>

<script>
	import countries from "../../countries.js"
	import states from "../../states.js"
	import Modal from "../Modal.vue"

	export default {
		components: {
			Modal
		},
		data() {
			return {
				idle: true,
				step: 1,
				languagesOpen: false,
				countries: countries,
				states: states,
				agreePrivacy: false,
				agreePsychic: false,
				languages: {
					1: "English",
					2: "Spanish",
					3: "French",
					5: "German",
					6: "Italian",
					7: "Russian",
					8: "Slovak",
				},
				errors: {
					referral: null,
					username: null,
					password: null,
					confirm_password: null,
					pin: null,
					first: null,
					last: null,
					address1: null,
					address2: null,
					postal_code: null,
					city: null,
					region: null,
					country: null,
					ssn: null,
					email: null,
					phone: null,
					zodiac: null,
					language: null,
					experience: null,
					credentials: null,
					checkPrivacy: null,
					checkPsychic: null,
				},
				psychic: {
					referral: "",
					username: "",
					ssn: "",
					password: "",
					confirm_password: "",
					pin: "",
					first: "",
					last: "",
					address1: "",
					address2: "",
					postal_code: "",
					phone_type: 1,
					city: "",
					region: "",
					country: "",
					email: "",
					phone: "",
					country_code: 1,
					contact_method: "P",
					zodiac: "",
					gender: "F",
					language: 1,
					languages: [],
					experience: "",
					credentials: [""],
					sms: false,
				}
			}
		},
		props: {
			agreement: String,
			manager: {
				type: Boolean,
				default: false
			}
		},
		computed: {
			langSelectDivCount() {
				return Math.ceil(Object.keys(this.languages).length/2)
			},
			selectedLanguageString() {
				let langs = []
				for (let i = 0; i < this.psychic.languages.length; i++) {
					langs.push(this.languages[this.psychic.languages[i]])
				}
				return langs.join(", ")
			},
			stateList() {
				if (this.psychic.country !== "") {
					return this.states.filter((s) => s.country_abbr == this.psychic.country)
				}
				return []
			},
			regionDomestic() {
				return ["", "US", "CA"].includes(this.psychic.country)
			},
			regionLabel() {
				if (["", "US", "CA"].includes(this.psychic.country)) {
					return "State/Prov"
				}
				return "Region"
			},
			phone: {
				get() {
					const phone = this.psychic.phone
					if (this.psychic.country_code === 1) {
						return `${phone.slice(0, 3)}${phone.length > 3 ? '-' : ''}${phone.slice(3, 6)}${phone.length > 6 ? '-' : ''}${phone.slice(6)}`
					}
					return phone
				},
				set(newValue) {
					this.psychic.phone = newValue.replace(/-/g, '')
				}
			}
		},
		methods: {
			printerFriendly() {
				window.open(this.agreement,'pgname','width=700,height=500,status=no,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no')
			},
			agreementUri() {
				if (this.getSite() === "COS") {
					return "https://api.circleofstars.com/cos_agreement.html"
				} else if (this.getSite() === "OS") {
					return "https://api.onesun.com/os_agreement.html"
				} 
			},
			getSite() {
				if (window.location.hostname.includes("circleofstars.com")) {
					return "COS"
				}

				if(window.location.hostname.includes("onesun.com")) {
					return "OS"
				}

				return "COS"
			},
			fixOtherLanguages(e) {
				let newLangs = []
				for (let i = 0; i < this.psychic.languages.length; i++) {
					if(parseInt(e.target.value) !== this.psychic.languages[i]) {
						newLangs.push(this.psychic.languages[i])
					}
				}
				this.psychic.languages = newLangs
				this.psychic.language = parseInt(e.target.value)
			},
			languageKeyByIndex(idx) {
				return Object.keys(this.languages)[idx]
			},
			addCredential() {
				this.psychic.credentials.push("")
			},
			removeCredential(idx) {
				let newCreds = []
				for(let i = 0; i < this.psychic.credentials.length; i++) {
					if (i === idx) {
						continue
					} else {
						newCreds.push(this.psychic.credentials[i])
					}
				}
				this.psychic.credentials = newCreds
			},
			checkReferral() {
				this.errors.referral = null
				if (this.psychic.referral !== "" && !/^\d{2,6}$/.test(this.psychic.referral)) {
					this.errors.referral = "Referral is invalid"
				}

				return this.errors.referral === null
			},
			async checkUsername() {
				this.errors.username = null
				if (this.psychic.username === "") {
					this.errors.username = "Username is required"
				} else if (this.psychic.username.length > 99) {
					this.errors.username = "Username is invalid"
				} else if (!(await this.$root.$data.getters.usernameAvailable(this.$root.$data.state, this.psychic.username))) {
					this.errors.username = "Username is taken"
				}

				return this.errors.username === null
			},
			checkPassword() {
				this.errors.password = null
				if (this.psychic.password === "") {
					this.errors.password = "Password is required"
				} else if (this.psychic.password.length < 6 || this.psychic.password.length > 50) {
					this.errors.password = "Password is invalid"
				}

				return this.errors.password === null
			},
			checkConfirmPassword() {
				this.errors.confirm_password = null
				if (this.psychic.confirm_password === "") {
					this.errors.confirm_password = "Password Confirmation is required"
				} else if (this.psychic.confirm_password !== this.psychic.password) {
					this.errors.confirm_password = "Passwords do not match"
				}

				return this.errors.confirm_password === null
			},
			async createPsychic() {
				this.idle = false;
				try {
					await this.$root.$data.setters.createPsychic(this.$root.$data.state, this.psychic)
				} catch(e) {console.log(e)}
				this.idle = true;
			},
			async checkPin() {
				console.log(this.psychic.pin)
				this.errors.pin = null
				if (this.psychic.pin === "") {
					this.errors.pin = "Pin is required"
				} else if (!/^\d{4}$/.test(this.psychic.pin)) {
					this.errors.pin = "Pin is invalid, must be 4 numbers."
				}

				if (this.psychic.phone !== "" && this.psychic.pin !== "" &&
				this.errors.pin === null && this.errors.phone === null) {
					if (!(await this.$root.$data.getters.phonePinAvailable(this.$root.$data.state, this.psychic.phone, this.psychic.pin))) {
						this.errors.username = "Phone/Pin combo is taken"
					}
				}

				return this.errors.pin === null
			},
			checkFirst() {
				this.errors.first = null
				if (this.psychic.first === "") {
					this.errors.first = "First Name is required"
				} else if (this.psychic.first.length > 50) {
					this.errors.first = "First Name is invalid"
				}

				return this.errors.first === null
			},
			checkLast() {
				this.errors.last = null
				if (this.psychic.last == "") {
					this.errors.last = "Last Name is required"
				} else if (this.psychic.last.length > 50) {
					this.errors.last = "Last Name is invalid"
				}

				return this.errors.last === null
			},
			checkAddress1() {
				this.errors.address1 = null
				if (this.psychic.address1 == "") {
					this.errors.address1 = "Address1 is required"
				} else if (this.psychic.address1.length > 99) {
					this.errors.address1 = "Address1 is invalid"
				}

				return this.errors.address1 === null
			},
			checkAddress2() {
				this.errors.address2 = null
				if (this.psychic.address2.length > 99) {
					this.errors.address2 = "Address2 is invalid"
				}

				return this.errors.address2 === null
			},
			checkPostalCode() {
				this.errors.postal_code = null

				if(this.psychic.postal_code === "") {
					this.errors.postal_code = "Zip/Postal Code is required"
				} else if (/^\d{5}$/.test(this.psychic.postal_code) && this.psychic.country === "US") {
					this.$root.$data.getters.getCityState(this.$root.$data.state, this.psychic.postal_code).then((cs) => {
						if (cs.length > 0) {
							this.psychic.city = cs[0].city
							this.psychic.region = cs[0].state
						}
					})
				} else if (this.psychic.country === "US"){
					this.errors.postal_code = "Zip/Postal Code is invalid"
				}

				return this.errors.postal_code === null
			},
			checkCity() {
				this.errors.city = null
				if (this.psychic.city === "") {
					this.errors.city = "City is required"
				} else if (this.psychic.city.length > 99) {
					this.errors.city = "City is invalid"
				}

				return this.errors.city === null
			},
			checkRegion() {
				this.errors.region = null
				if (this.psychic.region === "") {
					this.errors.region = "State/Region is required"
				} else if (this.psychic.region.length > 99) {
					this.errors.region = "State/Region is invalid"
				}

				return this.errors.region === null
			},
			checkCountry() {
				this.errors.country = null

				if (this.psychic.country != "") {
					this.psychic.country_code = parseInt(this.countries.filter((c) => c.country_code === this.psychic.country)[0].intl_prefix.trim())
				} else{
					this.psychic.country_code = 1
					this.errors.country = "Country required"
				}

				return this.errors.country === null
			},
			checkSsn() {
				this.errors.ssn = null
				if (this.psychic.ssn === "") {
					this.errors.ssn = "SSN is required"
				} else if (!/^\d{9}$/.test(this.psychic.ssn)) {
					this.errors.ssn = "SSN is invalid"
				}

				return this.errors.ssn === null
			},
			checkEmail() {
				this.errors.email = null
				if (this.psychic.email === "") {
					this.errors.email = "Email is required"
				} if (this.psychic.email.length > 99) {
					this.errors.email =- "Email is not valid"
				}

				return this.errors.email === null
			},
			siteName() {
				if (this.getSite() === 'COS') {
					return "Circle of Stars"
				}
				return "One Sun"
			},
			async checkPhone() {
				this.errors.phone = null
				if (this.psychic.phone.length === 0) {
					this.errors.phone = "Phone is required."
				} else if (this.psychic.country_code === 1 && !/^\d{10}$/.test(this.psychic.phone)) {
					this.errors.phone = "Phone is not valid"
				}

				if (this.psychic.phone !== "" && this.psychic.pin !== "" &&
				this.errors.pin === null && this.errors.phone === null) {
					if (!(await this.$root.$data.getters.phonePinAvailable(this.$root.$data.state, this.psychic.phone, this.psychic.pin))) {
						this.errors.phone = "Phone/Pin combo is taken"
					}
				}

				return this.errors.phone === null
			},
			checkZodiac() {
				this.errors.zodiac = null
				if (this.psychic.zodiac === "") {
					this.errors.zodiac = "Zodiac Sign is required"
				}

				return this.errors.zodiac === null
			},
			checkExperience() {
				this.errors.experience = null
				if (this.psychic.experience === "") {
					this.errors.experience = "Years Experience is required"
				} else if (!/^\d{2}$/.test(this.psychic.experience)) {
					this.errors.experience = "Years Experience is invalid. Must be numeric."
				}

				return this.errors.experience === null
			},
			async checkStep(step) {
				let valid = true
				switch (step) {
					case 1:
						valid = this.checkReferral() && valid
						valid = await this.checkUsername() && valid
						valid = this.checkPassword() && valid
						valid = this.checkConfirmPassword() && valid
						valid = await this.checkPin() && valid
						break
					case 2:
						valid = this.checkFirst() && valid
						valid = this.checkLast() && valid
						valid = this.checkAddress1() && valid
						valid = this.checkAddress2() && valid
						valid = this.checkCountry() && valid
						valid = this.checkPostalCode() && valid
						valid = this.checkCity() && valid
						valid = this.checkRegion() && valid
						valid = this.checkSsn() && valid
						valid = this.checkEmail() && valid
						valid = await this.checkPhone() && valid
						break
					case 3:
						valid = this.checkZodiac() && valid
						valid = this.checkExperience() && valid
						break
					case 4:
						valid = this.checkPsychic() && valid
						valid = this.checkPrivacy() && valid
				}

				return valid
			},
			checkPrivacy() {
				this.errors.checkPrivacy = null

				if (!this.agreePrivacy) {
					this.errors.checkPrivacy = 'You must agree to the Privacy Policy'
				}

				return this.errors.checkPrivacy === null
			},
			checkPsychic() {
				this.errors.checkPsychic = null

				if (!this.agreePsychic) {
					this.errors.checkPsychic = "You must confirm you are psychic"
				}

				return this.errors.checkPsychic === null
			},
			checkCredentials() {

			},
			async advanceStep() {
				if (await this.checkStep(this.step)) {
					if (this.step === 3 && this.manager) {
						await this.createPsychic()
						this.$notify({
								group: 'global',
								type: 'success',
								title: 'Psychic Created',
								text: 'The Psychic was created successfully.',
							})
							this.$router.push("/approvals")
					}
					else if (this.step === 4 && !this.manager) {
						try {
							await this.createPsychic()
							this.step++
						} catch{ return; }
					} else {
						this.step++
						window.scrollTo(0,0)
						document.activeElement.blur()
					}
				} 
			},
			receedStep(){
				this.step--
			},
			getStepBarClasses(step) {
				return {'is-active': this.step === step, 'is-completed': this.step > step }
			}
		}
	}
</script>